import { SearchFieldInterface } from "../../../../../kernel/listing/search-input/interfaces/search-field";

export const searchStockConfig = (): SearchFieldInterface[] =>
  <SearchFieldInterface[]>[
    {
      label: "STOCK_TYPE.COMMON.NAME",
      key: "name",
      value: true,
    },
    {
      label: "STOCK_TYPE.COMMON.CODE",
      key: "code",
      value: true,
    },
  ];
